<ng-container *transloco="let t">
  <div class="pt-62-32 pb-300-100">
    <div class="row">
      <div class="col-12">
        <app-section-subtitle [subtitle]="t('app.common.description')"/>
<!--        <div class="vertical-21-bottom">
          <img src="{{currentEventItem?.descriptionImage}}" alt="Event description image..." class="img-fluid"/>
        </div>-->
        <app-entry-list-item>
          <app-language-output [showAsInnerHtml]="getLabel()" [hrLabel]="currentEventItem?.description"
                               [enLabel]="currentEventItem?.descriptionEng"
                               [srLabel]="currentEventItem?.descriptionSr"
                               [bsLabel]="currentEventItem?.descriptionBs"
                               [itLabel]="currentEventItem?.descriptionIta" [siLabel]="currentEventItem?.descriptionSlo"
                               [defaultLanguage]="currentEventItem?.defaultLanguage"
                               [defaultLabel]="t('event.details.empty')" [languages]="languages"/>
        </app-entry-list-item>
        <app-section-subtitle [subtitle]="t('event.info.rules')"/>
<!--        <div class="vertical-21-bottom">
          <img src="{{currentEventItem?.rulesImage}}" alt="Event rules image..." class="img-fluid"/>
        </div>-->
        <app-entry-list-item>
          <app-language-output [showAsInnerHtml]="getLabel()" [hrLabel]="currentEventItem?.rules"
                               [enLabel]="currentEventItem?.rulesEng"
                               [srLabel]="currentEventItem?.rulesSr"
                               [bsLabel]="currentEventItem?.rulesBs"
                               [itLabel]="currentEventItem?.rulesIta" [siLabel]="currentEventItem?.rulesSlo"
                               [defaultLanguage]="currentEventItem?.defaultLanguage"
                               [defaultLabel]="t('event.rules.details.empty')" [languages]="languages"/>
        </app-entry-list-item>
      </div>
<!--      <div class="col-12 col-xxl-4 order-1 order-xxl-2">-->
<!--        <app-section-subtitle [subtitle]="t('event.info.mediaContent')"/>-->
<!--        <app-entry-list-item>-->
<!--          <div>-->
<!--            <app-language-output [hrLabel]="currentEventItem?.mediaContentHor"-->
<!--                                 [enLabel]="currentEventItem?.mediaContentHorEng"-->
<!--                                 [itLabel]="currentEventItem?.mediaContentHorIta"-->
<!--                                 [siLabel]="currentEventItem?.mediaContentHorSlo"-->
<!--                                 [defaultLanguage]="currentEventItem?.defaultLanguage"-->
<!--                                 [defaultLabel]="t('event.mediaContentHor.details.empty')" [languages]="languages"/>-->
<!--            <app-youtube-embed [youtubeUrl]="mediaVideoHor"/>-->
<!--          </div>-->
<!--          <div>-->
<!--            <app-language-output [hrLabel]="currentEventItem?.mediaContentVert"-->
<!--                                 [enLabel]="currentEventItem?.mediaContentVertEng"-->
<!--                                 [itLabel]="currentEventItem?.mediaContentVertIta"-->
<!--                                 [siLabel]="currentEventItem?.mediaContentVertSlo"-->
<!--                                 [defaultLanguage]="currentEventItem?.defaultLanguage"-->
<!--                                 [defaultLabel]="t('event.mediaContentVert.details.empty')" [languages]="languages"/>-->
<!--            <app-youtube-embed [youtubeUrl]="mediaVideoVert"/>-->
<!--          </div>-->
<!--        </app-entry-list-item>-->
<!--        <div class="d-none d-xxl-flex">-->
<!--          <ng-container *ngTemplateOutlet="galleryTemplate"></ng-container>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col-12 order-3">-->
<!--        <div class="d-flex w-100 d-xxl-none">-->
<!--          <ng-container *ngTemplateOutlet="galleryTemplate"></ng-container>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
  <ng-template #galleryTemplate>
    <app-section-subtitle [subtitle]="t('event.info.Gallery')" [isSmall]="true"/>
    <app-entry-list-item/>
  </ng-template>
</ng-container>
